(function() {
	'use strict';

	angular
		.module('directives')
		.directive('copyToClipboard', copyToClipboard);

	copyToClipboard.$inject = ['$window'];

	function copyToClipboard ($window) {
		var body = angular.element($window.document.body);
		var textarea = angular.element('<textarea></textarea>');
		textarea.css({
			position: 'fixed',
			opacity: '0'
		});

		function copy(toCopy) {
			textarea.val(toCopy);
			body.append(textarea);
			textarea[0].select();

			try {
				document.execCommand('copy');
			} catch (err) {}

			textarea.remove();
		}

		return {
			restrict: 'A',
			link: function (scope, element, attrs) {
				element.bind('click', function (e) {
					copy(attrs.copyToClipboard);
				});
			}
		};
	}
})();
